; (function ($) {

    'use strict';

    $(document).ready(function () {
        $('.form.form-contact').each(function () {


            $(this).on('submit.validate', 'form.validate', function (e) {
                e.preventDefault();
                var $form = $(this);
                if ($form.validate({
                    fields: $form.find('input.validate, select.validate, textarea.validate')
                }, function (validated) {
                    validated && $(document).off('submit.validate') && $form.submit();
                }));
            });


            $(this).on('click', 'input.validate[type=checkbox], input.validate[type=radio]', function (event) {
                var $input = $(this);
                var $siblings = $input.closest('form').find('input[name=' + $input.attr('name') + ']');
                $siblings.closest('label').removeClass('selected');
                $siblings.filter(':checked').each(function () {
                    $(this).closest('label').addClass('selected');
                });
                $(this).closest('form').validate({
                    fields: this
                });
            });

            $(this).on('blur', 'input.validate:not([type=checkbox], [type=radio]), select.validate, textarea.validate', function (e) {

                $(this).closest('form').validate({
                    fields: this
                });
                if (
                    e.relatedTarget &&
                    e.relatedTarget.type == "button"
                ) {

                    var validate = $(e.relatedTarget).data('validate');
                    console.log('blurvalidate:' + validate);
                    if (validate) {

                        var $form = $(e.relatedTarget).closest('form');
                        var $tab = $(e.relatedTarget).closest('.tab');
                        $form.validate({
                            fields: $tab.find('.validate'),
                            data: {
                                step: 2
                            }
                        }, function (validated, response) {
                            if (response.success && response.message) {

                                // On attribue une valeur prospect à partir des valeurs des formations
                                var nb_themes = 0;
                                var valeur_prospect = 0;

                                const valeur_themes = {
                                    'cD': 44, // Access
                                    'cp': 66, // Arabe
                                    'co': 130, // Chinois
                                    'da': 130, // Illustrator
                                    'cR': 55, // COMPTABILITE
                                    'cX': 55 // PAYE
                                };


                                // Sinon 200
                                const valeur_themes_defaut = 200;

                                const formData = new FormData($form[0]);

                                for (const pair of formData.entries()) {
                                    if (pair[0].indexOf('theme[') != -1) {
                                        nb_themes++;

                                        if (valeur_themes[pair[1]]) {
                                            valeur_prospect += valeur_themes[pair[1]];
                                        } else {
                                            valeur_prospect += valeur_themes_defaut;
                                        }
                                    }
                                }


                                var url_page = $(location).attr('href');
                                var tab_url_page = url_page.split("formationcontinue.com");
                                if (tab_url_page[1] == "/nous-contacter") {
                                    var form_id_val = "form-contact";
                                } else if (tab_url_page[1] == "" || tab_url_page[1] == "/") {
                                    var form_id_val = "form-contact-bottom";
                                } else {
                                    var form_id_val = "form-contact-popin";
                                }

                                var email_cl = $('#field-email').val();
                                var phone_number_cl = $('#field-phone').val();
                                phone_number_cl = phone_number_cl.replace("+33", "0");

                                dataLayer.push({
                                    'event': 'cf7submission',
                                    'valeur_prospect': Math.round(valeur_prospect / nb_themes), // Moyenne
                                    'form_id': form_id_val,
                                    'email': email_cl,
                                    'phone_number': phone_number_cl
                                });

                                console.log('url: ' + tab_url_page[1]);

                                //choix du calendly si bilan de competence ou autre
                                if ($('#field-theme-0 option:selected').val() == 'dw') {
                                    if ($('#professionnel').is(':checked')) {
                                        var tagCalendar = $('#tag-calendar-professionnel-bilan').html();
                                    } else {
                                        var tagCalendar = $('#tag-calendar-bilan').html();
                                    }
                                } else {
                                    if ($('#professionnel').is(':checked')) {
                                        var tagCalendar = $('#tag-calendar-professionnel-formation').html();
                                    } else {
                                        var tagCalendar = $('#tag-calendar').html();
                                    }

                                }
                                console.log(tagCalendar);

                                $form.empty();

                                var nbSteps = parseInt($form.closest('.stepper').find('.steps').data('nbSteps'));

                                if (2 === nbSteps) {
                                    $('<div class="feedback success">').html(response.message).insertBefore($form);
                                }


                                $form.append(tagCalendar);


                                var calendlyWidget = document.querySelector('.calendly-inline-widget');
                                calendlyInitInlineWidgetCall(calendlyWidget, $form, formData);
                            }


                            // validated && step && ga && ga('send', 'pageview', '/contact/step-' + step);
                            validated;    // commenté pour test 24-01-2024 && ga && ga('send', 'pageview', '/contact/step-');

                        });
                    } else {
                        //  target && switchTab(target);
                        console.log('no validated1');
                    }
                }
            });

            $(this).on('click', 'button', function (event) {
                event.preventDefault();

                var validate = $(this).data('validate');
                console.log('clicvalidate:' + validate);
                if (validate) {
                    var $form = $(this).closest('form');

                    var $tab = $(this).closest('.tab');
                    $form.validate({
                        fields: $tab.find('.validate'),
                        data: {
                            step: 2
                        }
                    }, function (validated, response) {
                        if (response.success && response.message) {


                            // On attribue une valeur prospect à partir des valeurs des formations
                            var nb_themes = 0;
                            var valeur_prospect = 0;

                            const valeur_themes = {
                                'cD': 44, // Access
                                'cp': 66, // Arabe
                                'co': 130, // Chinois
                                'da': 130, // Illustrator
                                'cR': 55, // COMPTABILITE
                                'cX': 55 // PAYE
                            };

                            // Sinon 200
                            const valeur_themes_defaut = 200;

                            const formData = new FormData($form[0]);

                            for (const pair of formData.entries()) {
                                if (pair[0].indexOf('theme[') != -1) {
                                    nb_themes++;

                                    if (valeur_themes[pair[1]]) {
                                        valeur_prospect += valeur_themes[pair[1]];
                                    } else {
                                        valeur_prospect += valeur_themes_defaut;
                                    }
                                }
                            }

                            var url_page = $(location).attr('href');
                            var tab_url_page = url_page.split("formationcontinue.com");
                            if (tab_url_page[1] == "/nous-contacter") {
                                var form_id_val = "form-contact";
                            } else if (tab_url_page[1] == "" || tab_url_page[1] == "/") {
                                var form_id_val = "form-contact-bottom";
                            } else {
                                var form_id_val = "form-contact-popin";
                            }

                            var email_cl = $('#field-email').val();
                            var phone_number_cl = $('#field-phone').val();
                            phone_number_cl = phone_number_cl.replace("+33", "0");

                            dataLayer.push({
                                'event': 'cf7submission',
                                'valeur_prospect': Math.round(valeur_prospect / nb_themes), // Moyenne
                                'form_id': form_id_val,
                                'email': email_cl,
                                'phone_number': phone_number_cl
                            });

                            //choix du calendly si bilan de competence ou autre
                            if ($('#field-theme-0 option:selected').val() == 'dw') {
                                if ($('#professionnel').is(':checked')) {
                                    var tagCalendar = $('#tag-calendar-professionnel-bilan').html();
                                } else {
                                    var tagCalendar = $('#tag-calendar-bilan').html();
                                }
                            } else {
                                if ($('#professionnel').is(':checked')) {
                                    var tagCalendar = $('#tag-calendar-professionnel-formation').html();
                                } else {
                                    var tagCalendar = $('#tag-calendar').html();
                                }
                            }
                            console.log(tagCalendar);
                            $form.empty();

                            var nbSteps = parseInt($form.closest('.stepper').find('.steps').data('nbSteps'));

                            if (2 === nbSteps) {
                                $('<div class="feedback success">').html(response.message).insertBefore($form);
                            }


                            $form.append(tagCalendar);


                            var calendlyWidget = document.querySelector('.calendly-inline-widget');
                            calendlyInitInlineWidgetCall(calendlyWidget, $form, formData);

                        }

                        validated;


                    });
                } else {
                    //target && switchTab(target);
                    console.log('no validated2');
                }
            });





            $('#field-status').on('change', function (event) {
                $('#field-status-person')
                    .trigger('change')
                    .closest('.form-conditionnal')
                    .toggle($(this).val() == 'Particuliers')
                    .find('input, select, textarea').prop('disabled', $(this).val() != 'Particuliers');
                $('[for=field-status-company]')
                    .closest('.form-conditionnal')
                    .toggle($(this).val() == 'Entreprise')
                    .find('input, select, textarea').prop('disabled', $(this).val() != 'Entreprise');
                $('#field-funding')
                    .closest('.form-conditionnal')
                    .toggle($(this).val() == 'Entreprise')
                    .find('input, select, textarea').prop('disabled', $(this).val() != 'Entreprise');
            });
            $('#field-status-person').on('change', function (event) {
                $('#field-status-person-other')
                    .closest('.form-conditionnal')
                    .toggle($('#field-status').val() == 'Particuliers' && $(this).val() == 'Autres')
                    .find('input, select, textarea').prop('disabled', $('#field-status').val() == 'Particuliers' && $(this).val() != 'Autres');
            });
            $('#field-funding').on('change', function (event) {
                $('#field-funding-other')
                    .closest('.form-conditionnal')
                    .toggle($(this).val() == 'Autres')
                    .find('input, select, textarea').prop('disabled', $(this).val() != 'Autres');
                $('#field-funding-ocpa')
                    .closest('.form-conditionnal')
                    .toggle($(this).val() == 'CPF')
                    .find('input, select, textarea').prop('disabled', $(this).val() != 'CPF');
            });
            $('#field-callback').on('change', function (event) {
                $('#field-callback-range')
                    .closest('.form-conditionnal')
                    .toggle($(this).val() == 'Oui')
                    .find('input, select, textarea').prop('disabled', $(this).val() != 'Oui');
            });

            $(".submit-button").on("click", function (e) {
                const finalStep = document.querySelector('.final-step');
                const checkboxChecked = finalStep.querySelector('.rgpd-checkbox').checked;
                const formationSelect = finalStep.querySelector('.formation-select');
                const formationSelectArray = Array.from(formationSelect);
                let allSelectHasValue = false;

                formationSelectArray.forEach(select => {
                    if (select.value.length > 0) {
                        allSelectHasValue = true;
                    } else {
                        allSelectHasValue = false;
                    }
                });


            })

            $(".cta-step").on("click", function (e) {
                if (window.innerWidth < 959) {
                    $(window).scrollTop($(".contact-form-part").offset().top - 20)

                }
            })
        });


    });

})(jQuery);

function isCalendlyEvent(e) {
    return e.origin === "https://calendly.com" && e.data.event && e.data.event.indexOf("calendly.") === 0;
};

window.addEventListener("message", function (e) {
    if (isCalendlyEvent(e)) {
        if ('calendly.date_and_time_selected' === e.data.event && jQuery('.feedback.success').is(':visible')) {
            jQuery('.feedback.success').slideUp();
        }

        if ('calendly.event_scheduled' === e.data.event) {
            let $forms = jQuery('.form-contact.stepper');
            let $formVisible = $forms.filter(function () {
                return jQuery(this).is(':visible');
            }).first();

            if ($formVisible.length) {
                let formContainer = $formVisible;

                // Dernière étape
                let totalSteps = parseInt(formContainer.find('.steps').attr('data-nb-steps'));
                formContainer.attr('data-current-step', totalSteps);

                if (jQuery('dialog.single-formation-modal-contact').is(':visible')) {
                    jQuery('dialog.single-formation-modal-contact').animate({
                        scrollTop: jQuery('dialog.single-formation-modal-contact').scrollTop() + (jQuery('.form.form-generic.form-contact.stepper').offset().top - jQuery('.form.form-generic.form-contact.stepper .steps').height())
                    }, 500);
                } else {
                    jQuery('html, body').animate({
                        scrollTop: formContainer.find('.steps').offset().top - 10
                    }, 500);
                }
            }
        }
    }
});

function calendlyInitInlineWidgetCall(calendlyWidget, form, formData) {
    let formDataEntries = Object.fromEntries(formData.entries());
    let calendlyWidgetPrefill = {
        name: formDataEntries['firstname'] + ' ' + formDataEntries['lastname'],
        email: formDataEntries['email'],
        customAnswers: {
            a1: formDataEntries['phone'],
            a2: formDataEntries['zip-code'],
        }
    };

    jQuery.getScript('https://assets.calendly.com/assets/external/widget.js', function () {
        let widget = calendlyWidget;
        let url = new URL(widget.dataset.url);
        ['hide_gdpr_banner'].forEach(param => {
            if (!url.searchParams.has(param)) url.searchParams.set(param, '1');
        });

        let calendlyWidgetUrl = url.toString();

        Calendly.initInlineWidget({
            url: calendlyWidgetUrl,
            parentElement: calendlyWidget,
            prefill: calendlyWidgetPrefill
        });

        // On mets à jour l'étape actuelle
        let formContainer = form.closest('.stepper');
        let currentStep = parseInt(formContainer.data('current-step'));
        formContainer.attr('data-current-step', currentStep + 1);

        if (jQuery('dialog.single-formation-modal-contact').is(':visible')) {
            jQuery('dialog.single-formation-modal-contact').animate({
                scrollTop: jQuery('dialog.single-formation-modal-contact').scrollTop() + (jQuery('.form.form-generic.form-contact.stepper').offset().top - jQuery('.form.form-generic.form-contact.stepper .steps').height())
            }, 500);
        } else {
            jQuery('html, body').animate({
                scrollTop: formContainer.find('.steps').offset().top - 10
            }, 500);
        }
    });
}